import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { translator } from 'mage-i18n';
import { IllustrationSuccess, Typography, SpacerVertical } from '@klarna/bubble-ui';

import { ContainerTemplate, MessagingStep } from '@/components';

const tPrefix = 'products-fe.containers.document_upload_success';

const DocumentUploadSuccess = ({ t }) => {
  return (
    <ContainerTemplate>
      <MessagingStep illustration={<IllustrationSuccess />} title={[t(`${tPrefix}.title`)]}>
        <SpacerVertical small />
        <Typography textToken="text-style/text/super-paragraphs/tall/regular">
          {t(`${tPrefix}.message`)}
        </Typography>
      </MessagingStep>
    </ContainerTemplate>
  );
};

DocumentUploadSuccess.propTypes = {
  t: PropTypes.func.isRequired,
};

export default compose(
  connect(state => ({
    t: translator(state),
  })),
)(DocumentUploadSuccess);
